import { InviteModalMode } from "#webapp/src/components/invite-modal";
import { setOpenShareWithCoworkersModal } from "#webapp/src/state/actions/chrome-extension.actions";
import { setPricingDialogOpen } from "#webapp/src/state/actions/payments.actions";
import { Button } from "@clockwise/design-system";
import { Error as ErrorIcon } from "@clockwise/design-system/icons";
import {
  openBillingPage,
  openPricingPage,
  openTrialExtensionDialog,
} from "@clockwise/web-commons/src/util/upgradeLinks.util";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../state/reducers/root.reducer";
import { TrackingEvents, track } from "../../util/analytics.util";
import { copy } from "./plan-status-callout-copy";

export interface PlanStatusCalloutProps {
  calloutType: PlanStatusCalloutType;
  startOfNextCycle?: string;
  customDomainMessage?: string;
  showJoinExistingPlan?: boolean;
  trackingEvent: string;
}

export enum PlanStatusCalloutType {
  TrialExpired_FlexMeeting = "TrialExpired_FlexMeeting",
  TrialOverExpired_FlexMeeting = "TrialOverExpired_FlexMeeting",
  TrialExpired_Sidebar = "TrialExpired_Sidebar",
  TrialOneDayLeft_FocusTime = "TrialOneDayLeft_FocusTime",
  TrialOneDayLeft_FlexMeeting = "TrialOneDayLeft_FlexMeeting",
  QuotaExceeded = "QuotaExceeded",
}

export const PlanStatusCallout = ({
  startOfNextCycle,
  calloutType,
  customDomainMessage,
  showJoinExistingPlan,
  trackingEvent,
}: PlanStatusCalloutProps) => {
  const dispatch = useDispatch();
  const isExtension = useSelector((state: IReduxState) => state.webExtension.isWebExtension);

  const onClickCTA = () => {
    track(trackingEvent);
    if (showJoinExistingPlan) {
      openBillingPage();
    } else {
      if (isExtension) {
        dispatch(setPricingDialogOpen(true));
      } else {
        openPricingPage();
      }
    }
  };

  const calloutCopy = copy(startOfNextCycle, showJoinExistingPlan)[calloutType];

  const onClickExtendTrial = () => {
    track(TrackingEvents.TRIAL_EXTENSION.CTA_CLICKED);
    if (isExtension) {
      dispatch(setOpenShareWithCoworkersModal(true, InviteModalMode.TrialExtension));
    } else {
      openTrialExtensionDialog();
    }
  };

  return (
    <div className="cw-font-body cw-flex cw-gap-2 cw-p-2 cw-border cw-border-solid cw-rounded-lg cw-border-warning cw-bg-warning cw-text-warning">
      <ErrorIcon className="cw-text-20" />
      <div className="cw-flex cw-flex-col cw-gap-1 cw-mt-1">
        <div className="cw-heading-sm cw-text-warning">{calloutCopy.header}</div>
        <div className="cw-body-sm cw-text-warning">
          {customDomainMessage ? customDomainMessage : calloutCopy.text}
        </div>
        {!customDomainMessage && (
          <div className="cw-flex cw-items-center cw-gap-4 cw-mt-1">
            <Button sentiment="warning" onClick={onClickCTA} variant="outlined" size="small">
              {calloutCopy.button}
            </Button>
            <Button
              sentiment="neutral"
              onClick={onClickExtendTrial}
              variant="outlined"
              size="small"
            >
              Extend Trial
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
